import { TrackOrgProp, TrackUserProp } from '@studio/constants/tracking-constants';
import type { Segment } from '@studio/types';

const _mergeEventProps = (
  eventProps: Record<string, unknown> | undefined,
  auth: Segment.Derived.TrackSegmentAuthContext
): Record<string, unknown> => ({
  ...eventProps,
  [TrackUserProp.USER_NAME]: auth.userName,
  [TrackOrgProp.ORG_NAME]: auth.customerName,
  [TrackOrgProp.ORG_UUID]: auth.customerId,
});

/**
 * Fires a Segment `track` with auth enrichment (user/org).
 * For React views, prefer `useTrackSegment`; for sagas, call from `call()`.
 */
const trackSegmentWithAuth = (
  payload: Segment.Derived.TrackSegmentPayload,
  auth: Segment.Derived.TrackSegmentAuthContext
): void => {
  if (!window.analytics?.track) {
    return;
  }
  try {
    const mergedProps = _mergeEventProps(payload.eventProps, auth);
    window.analytics.track(payload.eventName, mergedProps);
  } catch (err) {
    if (err instanceof Error) {
      console.error(err);
    }
  }
};

export default trackSegmentWithAuth;
